// src/components/widgets/formTemplates.js

export const FORM_TEMPLATES = {
  refund_request: {
    guest: {
      title: "Refund Request Form",
      description: "Please provide the following information to process your refund:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'phone', label: 'Phone Number', type: 'tel', required: true, placeholder: '+254700123456' },
        { name: 'orderNumber', label: 'Order Number (if available)', type: 'text', required: false, placeholder: 'ORD123456' },
        { name: 'productName', label: 'Product Name', type: 'text', required: true, placeholder: 'Bambu Lab A1 Mini' },
        { name: 'refundReason', label: 'Reason for Refund', type: 'textarea', required: true, placeholder: 'Please explain why you need a refund...' }
      ],
      completion: "Thank you! I've created a priority refund request ticket. You'll receive an email confirmation and our team will process this within 24 hours."
    },
    user: {
      title: "Refund Request Form", 
      description: "Since you're logged in, I just need a few details:",
      fields: [
        { name: 'orderNumber', label: 'Order Number', type: 'text', required: false, placeholder: 'ORD123456' },
        { name: 'productName', label: 'Product Name', type: 'text', required: true, placeholder: 'Which product?' },
        { name: 'refundReason', label: 'Reason for Refund', type: 'textarea', required: true, placeholder: 'Please explain why you need a refund...' }
      ],
      completion: "Perfect! I've created your refund request. You'll receive updates at your registered email address."
    }
  },

  course_inquiry: {
    guest: {
      title: "Course Information Request",
      description: "I'd be happy to help you learn more about our academy courses! Please provide some details:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'interestArea', label: 'Area of Interest', type: 'text', required: false, placeholder: '3D printing basics, CAD design, etc.' },
        { name: 'experienceLevel', label: 'Experience Level', type: 'select', required: false, options: [{ value: 'beginner', text: 'Beginner' },
          { value: 'intermediate', text: 'Intermediate' },
          { value: 'advanced', text: 'Advanced' }], placeholder: 'Select your level' },
        { name: 'preferredTiming', label: 'Preferred Timing', type: 'text', required: false, placeholder: 'Weekends, evenings, etc.' }
      ],
      completion: "Thank you! I've sent your course inquiry to our academy team. They'll contact you within 24 hours with detailed information about our courses and enrollment options."
    },
    user: {
      title: "Course Information Request",
      description: "Since you're logged in, I just need a few details about your course interests:",
      fields: [
        { name: 'interestArea', label: 'Area of Interest', type: 'text', required: true, placeholder: 'What type of course are you interested in?' },
        { name: 'experienceLevel', label: 'Experience Level', type: 'select', required: false, options: [{ value: 'beginner', text: 'Beginner' },
          { value: 'intermediate', text: 'Intermediate' },
          { value: 'advanced', text: 'Advanced' }] },
        { name: 'preferredTiming', label: 'Preferred Schedule', type: 'text', required: false, placeholder: 'When would you like to take the course?' }
      ],
      completion: "Perfect! I've noted your course interests. Our academy team will reach out with personalized recommendations based on your profile."
    }
  },

  product_defective: {
    guest: {
      title: "Defective Product Report",
      description: "I'm sorry about the product issue. Please provide details:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'phone', label: 'Phone Number', type: 'tel', required: true, placeholder: '+254700123456' },
        { name: 'orderNumber', label: 'Order Number', type: 'text', required: true, placeholder: 'ORD123456' },
        { name: 'productName', label: 'Product Name', type: 'text', required: true, placeholder: 'Bambu Lab P1S' },
        { name: 'defectDescription', label: 'Describe the Issue', type: 'textarea', required: true, placeholder: 'What exactly is wrong with the product?' },
        { name: 'purchaseDate', label: 'Purchase Date', type: 'date', required: false }
      ],
      completion: "I've created a high-priority quality issue ticket. Our team will contact you within 4 hours to arrange a fix, replacement or refund."
    },
    user: {
      title: "Defective Product Report",
      description: "Please provide details about the defective product:",
      fields: [
        { name: 'orderNumber', label: 'Order Number', type: 'text', required: true, placeholder: 'ORD123456' },
        { name: 'productName', label: 'Product Name', type: 'text', required: true, placeholder: 'Which product?' },
        { name: 'defectDescription', label: 'Describe the Issue', type: 'textarea', required: true, placeholder: 'What exactly is wrong with the product?' },
        { name: 'purchaseDate', label: 'When did you receive it?', type: 'date', required: false }
      ],
      completion: "Quality issue reported! We'll contact you soon to arrange a solution."
    }
  },

  order_tracking: {
    guest: {
      title: "Order Tracking Request", 
      description: "Help me locate your order:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'phone', label: 'Phone Number', type: 'tel', required: false, placeholder: '+254700123456' },
        { name: 'orderNumber', label: 'Order Number', type: 'text', required: true, placeholder: 'ORD123456' }
      ],
      completion: "I'll locate your order details. Our team will provide you with tracking information shortly."
    },
    user: {
      title: "Order Tracking",
      description: "Let me track your order:",
      fields: [
        { name: 'orderNumber', label: 'Order Number', type: 'text', required: true, placeholder: 'ORD123456' }
      ],
      completion: "I'll locate your order status. You'll receive detailed tracking information shortly."
    }
  },

  account_issue: {
    guest: {
      title: "Account Issue Report",
      description: "Let me help resolve your account problem:",
      fields: [
        { name: 'email', label: 'Account Email', type: 'email', required: true, placeholder: 'your@email.com' },
        { name: 'platform', label: 'Which Platform?', type: 'select', required: true, options: [{ value: 'store', text: 'Online Store' },{ value: 'academy', text: 'Academy' },{ value: 'maker', text: 'Maker Platform' }], placeholder: 'Select platform' },
        { name: 'issueType', label: 'Issue Type', type: 'select', required: true, options: [{ value: 'login_issue', text: 'Login Problem' },{ value: 'password_reset', text: 'Password Reset' },{ value: 'account_locked', text: 'Account Locked' },{ value: 'access_denied', text: 'Access Denied' },{ value: 'other', text: 'Other' }], placeholder: 'Select issue type' },
        { name: 'issueDescription', label: 'Describe the Problem', type: 'textarea', required: true, placeholder: 'What exactly happened when you tried to access your account?' },
        { name: 'errorMessage', label: 'Error Message (if any)', type: 'textarea', required: false, placeholder: 'Copy any error messages you saw' }
      ],
      completion: "I've created an urgent account support ticket. Our technical team will contact you within 4 hours during business hours to resolve your access issue."
    },
    user: {
      title: "Account Issue Report", 
      description: "I'll help resolve your account problem:",
      fields: [
        { name: 'platform', label: 'Which Platform?', type: 'select', required: true, options: [{ value: 'store', text: 'Online Store' },{ value: 'academy', text: 'Academy' },{ value: 'maker', text: 'Maker Platform' }], placeholder: 'Select platform' },
        { name: 'issueType', label: 'Issue Type', type: 'select', required: true, options: [{ value: 'login_issue', text: 'Login Problem' },{ value: 'password_reset', text: 'Password Reset' },{ value: 'account_locked', text: 'Account Locked' },{ value: 'access_denied', text: 'Access Denied' },{ value: 'other', text: 'Other' }], placeholder: 'Select issue type' },
        { name: 'issueDescription', label: 'Describe the Problem', type: 'textarea', required: true, placeholder: 'What exactly happened?' }
      ],
      completion: "Account issue reported! Our team will investigate and contact you shortly."
    }
  },

  store_issue: {
    guest: {
      title: "Store Issue Report",
      description: "I'm sorry you're experiencing issues with our store:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'issueDescription', label: 'Describe the Problem', type: 'textarea', required: true, placeholder: 'What issue are you experiencing with the store?' },
        { name: 'errorMessage', label: 'Error Messages', type: 'textarea', required: false, placeholder: 'Any error messages you saw?' }
      ],
      completion: "I've created a store support ticket. Our technical team will investigate and contact you shortly."
    }
  },

  academy_issue: {
    guest: {
      title: "Academy Support Request",
      description: "I'm sorry you're having trouble with our academy:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'issueDescription', label: 'Describe the Problem', type: 'textarea', required: true, placeholder: 'What issue are you experiencing with the academy?' },
        { name: 'courseName', label: 'Course Name', type: 'text', required: false, placeholder: '3D Printing Basics, Advanced CAD, etc.' }
      ],
      completion: "I've created an academy support ticket. Our team will help you resolve this issue promptly."
    }
  },

  general_inquiry: {
    guest: {
      title: "General Inquiry",
      description: "I'd be happy to help with your inquiry:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'phone', label: 'Phone Number', type: 'tel', required: false, placeholder: '+254700123456' },
        { name: 'inquiryType', label: 'Inquiry Type', type: 'select', required: true, options: [{ value: 'general_info', text: 'General Information' },{ value: 'partnership', text: 'Partnership' },{ value: 'media_request', text: 'Media Request' },{ value: 'feedback', text: 'Feedback' },{ value: 'other', text: 'Other' }], placeholder: 'Select type' },
        { name: 'message', label: 'Your Message', type: 'textarea', required: true, placeholder: 'Please provide details about your inquiry...' }
      ],
      completion: "Thank you for your inquiry! Our team will review your message and respond within 48 hours."
    }
  },

  collaboration_request: {
    guest: {
      title: "Collaboration Request", 
      description: "We'd love to explore collaboration opportunities:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'company', label: 'Company/Organization', type: 'text', required: false, placeholder: 'Your company name' },
        { name: 'phone', label: 'Phone Number', type: 'tel', required: false, placeholder: '+254700123456' },
        { name: 'collaborationType', label: 'Type of Collaboration', type: 'select', required: true, options: [{ value: 'business_partnership', text: 'Business Partnership' },
          { value: 'educational_partnership', text: 'Educational Partnership' },
          { value: 'content_collaboration', text: 'Content Collaboration' },
          { value: 'technology_integration', text: 'Technology Integration' },
          { value: 'other', text: 'Other' }], placeholder: 'Select collaboration type' },
        { name: 'proposal', label: 'Collaboration Proposal', type: 'textarea', required: true, placeholder: 'Please describe your collaboration idea in detail...' }
      ],
      completion: "Thank you for your collaboration proposal! Our business development team will review it and respond within 3-5 business days."
    }
  },

  technical_support: {
    guest: {
      title: "Technical Support Request",
      description: "I'm here to help with your technical issue:",
      fields: [
        { name: 'fullName', label: 'Full Name', type: 'text', required: true, placeholder: 'John Doe' },
        { name: 'email', label: 'Email Address', type: 'email', required: true, placeholder: 'john@example.com' },
        { name: 'issueDescription', label: 'Describe the Technical Problem', type: 'textarea', required: true, placeholder: 'What technical issue are you experiencing?' },
        { name: 'productDetails', label: 'Product/Printer Model', type: 'text', required: false, placeholder: 'Bambu Lab P1S, A1 Mini, etc.' }
      ],
      completion: "I've created a technical support ticket. Our team will contact you to assist with troubleshooting."
    }
  }
};